import { render, staticRenderFns } from "./LiquidSubscriptionService.vue?vue&type=template&id=6ef974cf&scoped=true&"
import script from "./LiquidSubscriptionService.vue?vue&type=script&lang=js&"
export * from "./LiquidSubscriptionService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef974cf",
  null
  
)

export default component.exports